import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { changePassword } from "../../../types";
import { BiSearchAlt2 } from "react-icons/bi";
import { AiTwotoneHome } from "react-icons/ai";
import { TbReportMoney } from "react-icons/tb";
import { GiTakeMyMoney } from "react-icons/gi";
import { IoMdFingerPrint } from "react-icons/io";
import { BsCalendar3, BsPersonGear } from "react-icons/bs";
import { MdOutlineAddCircleOutline } from "react-icons/md";
import Storage from "../../../helpers/Storage";
import useModal from "../../../hooks/useModal";
import useAppContext from "../../../hooks/useAppContext";
import Logo2Src from "../../../assets/img/logo1.png";
import Form from "../../../components/form/Form";
import Title from "../../../components/text/Title";
import Modal from "../../../components/modal/Modal";
import Input from "../../../components/input/Input";
import Button from "../../../components/button/Button";
import Dropdown from "../../../components/dropdown/Dropdown";
import { TipoApp, useAuth } from "../../../hooks";
import { isGetAccessor } from "typescript";

export interface NavbarProps {
  pageTitle?: string;
}

export default function Navbar({ pageTitle }: NavbarProps) {
  const userData = Storage.getUserData();
  const { user, tipoApp } = useAuth();
  const navigate = useNavigate();
  const appContext = useAppContext();
  const { modalProps, open: openResetPasswordModal } = useModal();
  const { modalProps: modalProps2, open, close } = useModal();
  const { modalProps: searchStudentModalProps, open: openSearchStudentModal } = useModal();
  const { modalProps: searchTeacherModalProps, open: openSearchTeacherModal } = useModal();
  const [dataPassword, setDataPassword] = useState<changePassword>({
    atualPassword: "",
    novoPassword: "",
    repetirPassword: "",
  });

  const isGestaoApp = tipoApp === TipoApp.GESTAO;


  function handleLogout() {
    Storage.removeApiToken();
    Storage.removeUserData();
    window.location.href = "/";
  }

  async function changePassword(e: any) {
    /*e.preventDefault();
    if (dataPassword.novoPassword != dataPassword.repetirPassword) {
      Alert.error('Senhas São diferentes');
      return;
    }
    //salva a senha
    const {data, isError} = await adminApi.changePassword(dataPassword);
    if (isError) return Alert.error(data);
    Alert.success('Senha alterada com sucesso!');
    close();*/
  }

  useEffect(() => {
    console.log(user)
    if (userData) appContext.setUsuario(userData.usuario);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <nav className="bg-background  flex items-center">
      <aside className="w-[22rem]">
        <img src={Logo2Src} alt="" />
      </aside>
      
      <main className="flex items-center justify-end flex-1">
        <div className={"flex justify-end py-[15px] bg-slate-200 z-10"}>

          <div
            className="flex items-center gap-2  py-2 px-2 rounded-md cursor-pointer"
            onClick={() => navigate(isGestaoApp ? "/" : "/p")}
          >
            <AiTwotoneHome size={"40"} />
          </div>

          {isGestaoApp && <>
            <Dropdown
              trigger={
                <div className="flex items-center gap-2  py-2 px-3 rounded-md ">
                  <span className="flex flex-col items-start">
                    <MdOutlineAddCircleOutline size={"40"} />
                  </span>
                </div>
              }
              items={[
                { label: "+ ALUNO(A)", onClick: () => navigate("/alunos") },
                { label: "+ CONTRATOS", onClick: () => navigate("/alunos-cursos") },
                { label: "+ PROFESSOR(A)", onClick: () => navigate("/professores") },
                { label: "+ AVULSA", onClick: () => navigate("/avulsas") },
                { label: "+ INTENSIVO", onClick: () => navigate("/intensivos") },
                { label: "+ OFICINA", onClick: () => navigate("/oficinas") },
                { label: "+ NOVO CURSO", onClick: () => navigate("/cursos") },
                { label: "+ CLÁUSULAS", onClick: () => navigate("/clausulas") },
                { label: "+ NOVA SALA", onClick: () => navigate("/salas") },
              ]}
            />
          </>}

          <div
            className="flex items-center gap-2  py-2 px-2 rounded-md cursor-pointer"
            onClick={() => navigate(isGestaoApp ? "/calendario" : "/p/presencas")}
          >
            <BsCalendar3 size={"40"} />
          </div>

          {!isGestaoApp && <div
            className="flex items-center gap-2  py-2 px-2 rounded-md cursor-pointer"
            onClick={() => navigate("/p/alunos")}
          >
            <BiSearchAlt2 size={"40"} />
          </div>}

          {isGestaoApp && <Dropdown
            trigger={
              <div className="flex items-center gap-2  py-2 px-3 rounded-md">
                <span className="flex flex-col items-start">
                  <TbReportMoney size={"40"} />
                </span>
              </div>
            }
            items={[
              { label: "Categorias", onClick: () => navigate("/vendas-categorias") },
              { label: "Vendas", onClick: () => navigate("/vendas") },
              { label: "Vendas Clientes", onClick: () => navigate("/vendas-clientes") },
            ]}
          />}

          {isGestaoApp && <Dropdown
            trigger={
              <div className="flex items-center gap-2  py-2 px-3 rounded-md">
                <span className="flex flex-col items-start">
                  <GiTakeMyMoney size={"40"} />
                </span>
              </div>
            }
            items={[
              { label: "Contas Fixas", onClick: () => navigate("/despesas") },
              { label: "Despesas Extras", onClick: () => navigate("/despesas-extras") },
              { label: "Repasses", onClick: () => navigate("/repasses") },
              { label: "Clientes Ativos", onClick: () => navigate("/alunos-lista") },
            ]}
          />}

          {isGestaoApp && <Dropdown
            trigger={
              <div className="flex items-center gap-2  py-2 px-3 rounded-md">
                <span className="flex flex-col items-start">
                  <IoMdFingerPrint size={"40"} />
                </span>
              </div>
            }
            items={[
              { label: "Lista de Usuários", onClick: () => navigate("/usuarios") },
            ]}
          />}

          {isGestaoApp && <Dropdown
            trigger={
              <div className="flex items-center gap-2  py-2 px-3 rounded-md">
                <span className="flex flex-col items-start">
                  <BiSearchAlt2 size={"40"} />
                </span>
              </div>
            }
            items={[
              { label: "Aluno", onClick: openSearchStudentModal },
              { label: "Professor", onClick: openSearchTeacherModal },
            ]}
          />}

          <Dropdown
            trigger={
              <div className="flex items-center gap-2  py-2 px-3 rounded-md">
                <span className="flex flex-col items-start">
                  <BsPersonGear size={"40"} />
                </span>
              </div>
            }
            items={[
              // { label: "Alterar senha", onClick: openResetPasswordModal },
              { label: "Sair", onClick: handleLogout },
            ]}
          />
        </div>
      </main>

      {/* <Modal size="lg" title="Alterar Senha" {...modalProps}>
        <Form onSubmit={changePassword}>
          <div className={"p-3"}>
            <Input
              label="Senha"
              inputType="password"
              value={dataPassword.atualPassword}
              setValue={(atualPassword) =>
                setDataPassword({ ...dataPassword, atualPassword })
              }
            />

            <Input
              className={"mt-4"}
              label="Nova Senha"
              inputType="password"
              value={dataPassword.novoPassword}
              setValue={(novoPassword) =>
                setDataPassword({ ...dataPassword, novoPassword })
              }
            />

            <Input
              className={"mt-4"}
              label="Repetir Senha"
              inputType="password"
              value={dataPassword.repetirPassword}
              setValue={(repetirPassword) =>
                setDataPassword({ ...dataPassword, repetirPassword })
              }
            />
          </div>
          <div className={"p-3 flex "}>
            <Button type="submit">Salvar</Button>
            <Button onClick={close} className={"ml-5"}>
              Cancelar
            </Button>
          </div>
        </Form>
      </Modal> */}

      <Modal
        {...searchStudentModalProps}
        title="Buscar Alunos"
        size="lg"
        onOpen={() => {
          setTimeout(() => {
            document
              .getElementById("searchStudentModalInputContainer")
              ?.querySelector("input")
              ?.focus();
          }, 100);
        }}
      >
        <form
          id="searchStudentModalInputContainer"
          action="/alunos"
          method="get"
        >
          <Input name="q" />

          <br />
          <br />

          <Button variant="constancia" className="w-full" type="submit">
            Buscar
          </Button>
        </form>
      </Modal>

      <Modal
        {...searchTeacherModalProps}
        title="Buscar Professores"
        size="lg"
        onOpen={() => {
          setTimeout(() => {
            document
              .getElementById("searchTeacherModalInputContainer")
              ?.querySelector("input")
              ?.focus();
          }, 100);
        }}
      >
        <form
          id="searchTeacherModalInputContainer"
          action="/professores"
          method="get"
        >
          <Input name="q" />

          <br />
          <br />

          <Button variant="constancia" className="w-full" type="submit">
            Buscar
          </Button>
        </form>
      </Modal>
    </nav>
  );
}
